module.exports = __webpack_public_path__ + "img/type_1.1a0a8cba.png";